import { StandardEvents } from '@shopify/events';
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
 const fromProduct = event.target instanceof Element && event.target.closest('.ku-product-main');
 if (!fromProduct || !event.promise) return;
 event.promise.then(({ detail }) => {
  if (detail?.didError) return;
  const message = document.querySelector('.ku-product-cart-success');
  if (message) message.hidden = false;
  fetch(Theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
   .then(response => response.ok ? response.json() : Promise.reject())
   .then(cart => document.querySelectorAll('.ku-cart-count').forEach(counter => { counter.textContent = cart.item_count; }))
   .catch(() => {});
 }).catch(() => {});
});
